module.exports = __webpack_public_path__ + "img/yeekee.f9c4c1cf.webp";